import { useTheme } from "styled-components";
import { Text } from "../UI";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { blue } from "../UI/themes";

export const MenuItem = ({
  img,
  title,
  selected,
  navigateTo,
  setTitle,
  setOpen,
  isAdmin,
  style,
  onItemClicked,
  disabled,
  onDisabledClick,
}) => {
  const navigate = useNavigate();
  let theme = useTheme();
  const { t } = useTranslation("menu");

  if (!!isAdmin) {
    theme = blue;
  }

  const handleMenuItemSelect = (navigateTo, title) => {
    if (disabled) {
      onDisabledClick?.();
      return;
    }
    if (onItemClicked) {
      onItemClicked();
    } else {
      setTitle(title);
      setOpen(false);
      navigate(navigateTo);
    }
  };

  useEffect(() => {
    if (!selected) return;
    setTitle(title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  return (
    <div
      style={{
        ...style,
        display: "flex",
        flexDirection: "row",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.4 : 1,
        gap: 14,
        backgroundColor: selected ? "#EDEDFF" : theme.color.white,
        padding: `6px 14px`,
        alignItems: "center",
        borderRadius: 21,
      }}
      onClick={() => handleMenuItemSelect(navigateTo, title)}
    >
      <img src={img} alt="menu_item" style={{ width: 20, height: 20 }} />
      <Text.BM color={theme?.color?.gray90} style={{ textAlign: "center" }}>
        {t(title)}
      </Text.BM>
    </div>
  );
};

export default MenuItem;
